import React, { Component } from 'react';
import { Carousel, Button } from 'components';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PATH } from 'shared/constants';
import arrow from 'assets/icons/next.svg';
import { connect } from 'react-redux';
// import slide1Bg from 'assets/images/splash-bg-01.svg';
import awards from 'assets/images/awards.png';
// import slide2Bg from '/assets/splash-bg-02.svg';
// import slide3Bg from 'assets/images/splash-bg-03.svg';
import ReactSVG from 'react-svg';
import './Welcome.scss';
import baseUrl from 'shared/util/baseUrl';

import trackEvent from 'components/TrackEvent/TrackEvent';
import { eventSkipClick, eventLetsStartClick } from 'components/TrackEvent/constEvent';

class Welcome extends Component {

  render() {
    const { history, intl, currentLocale } = this.props;

    const slides = [
      {
        title: 'welcome.slide1Title',
        desc: 'welcome.slide1Desc',
        button: (
          <Link
            to={PATH.HOME}
            onClick={() => trackEvent(eventSkipClick(currentLocale, intl.formatMessage({ id: 'welcome.skip' })))}
          >
            <FormattedMessage id="welcome.skip" />
            <ReactSVG src={arrow} alt="Next" />
          </Link>
        ),
        // background: slide1Bg,
        background: `${baseUrl}/images/splash-bg-01.svg`,
        image: awards,
      },
      {
        title: 'welcome.slide2Title',
        desc: 'welcome.slide2Desc',
        button: (
          <Link
            to={PATH.HOME}
            onClick={() => trackEvent(eventSkipClick(currentLocale, intl.formatMessage({ id: 'welcome.skip' })))}
          >
            <FormattedMessage id="welcome.skip" />
            <ReactSVG src={arrow} alt="Next" />
          </Link>
        ),
        // background: slide2Bg,
        background: `${baseUrl}/images/splash-bg-02.svg`,
      },
      {
        title: 'welcome.slide3Title',
        desc: 'welcome.slide3Desc',
        button: <Button
          onButtonClick={() => {
            history.push(PATH.HOME);
            trackEvent(eventLetsStartClick(currentLocale, intl.formatMessage({ id: 'welcome.letsStart' })));
          }}
          value={intl.formatMessage({ id: 'welcome.letsStart' })}
          isBig
        />,
        // background: slide3Bg,
        background: `${baseUrl}/images/splash-bg-03.svg`,
      },
    ];
    return (
      <section className="app-wrapper__body nw-page-welcome">
        <Carousel
          isCenterMode
          withDots
          variableWidth
          centerPadding="0px"
        >
          {slides && slides.map((item, idx) => (
            <div key={idx}>
              <div
                className="nw-page-welcome__slide"
                style={{ backgroundImage: `url(${item.background})` }}
              >
                <h2>{intl.formatMessage({ id: item.title })}</h2>
                <p>{intl.formatMessage({ id: item.desc })}</p>
                {item.image && <img src={item.image} alt="Award" />}
                {item.button}
              </div>
            </div>
          ))}
        </Carousel>
      </section>
    );
  }
}


const mapStateToProps = state => ({
  currentLocale: state.rootReducer.language.locale,
});

export default connect(mapStateToProps)(injectIntl(Welcome));
